
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Contents from './components/Contents';
import SocialIssues from './components/SocialIssues';
import CurrentIssues from './components/CurrentIssues';
import VideoSection from './components/VideoSection';
import GenerationMeter from './components/GenerationMeter';
import Features from './components/Features';
import CatalogDownload from './components/CatalogDownload';
import BusinessPlan from './components/BusinessPlan';
import Patents from './components/Patents';
import Contact from './components/Contact';
import Footer from './components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />
      <Hero />
      <About />
      <Contents />
      <Features />
      <CatalogDownload />
      <SocialIssues />
      <CurrentIssues />
      <VideoSection />
      <GenerationMeter />
      <BusinessPlan />
      <Patents />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
